import { render, staticRenderFns } from "./organization-actions.vue?vue&type=template&id=399e8ebc&"
import script from "./organization-actions.vue?vue&type=script&lang=ts&"
export * from "./organization-actions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports